import { withStyles, LinearProgress } from "@material-ui/core";
import PropTypes from "prop-types";
import React, { useContext } from "react";
import moment from "moment";
import SPScrollbar from "../../../components/Navigation/SPScrollbar";
import TimelineDateSection from "./TimelineDateSection";
import { vehicleHistoryStyles } from "./subcomponents/sharedStyles";
import {
  TimelineEvent,
  TimelineStatus,
  TripTimelineStatus,
} from "../../../services/timeline.service";
import TimelineHeader from "./TimelineHeader";
import { FleetContext } from "../../../context";

export const VehicleHistoryTimeline = ({
  classes,
  handleClick,
  entriesByDate,
  onShowPathChange,
  visibleEvents,
  visibleEventTimestamp,
  updating,
}) => {
  const tomorrow = moment().add(1, "day").format("YYYY-MM-DD");
  let { maxTimelineDate } = useContext(FleetContext);
  maxTimelineDate = moment(maxTimelineDate).format("YYYY-MM-DD");

  return (
    <div className={classes.timeLineRoot}>
      <TimelineHeader />
      {updating && <LinearProgress color="secondary" />}
      <SPScrollbar noScrollX>
        {Object.entries(entriesByDate).map(([date, timelineStatusesArray], index) => (
          <TimelineDateSection
            key={`datesection-${date}`}
            date={date}
            timelineStatusesArray={timelineStatusesArray}
            handleClick={handleClick}
            visibleEventTimestamp={visibleEventTimestamp}
            mostRecent={!updating && tomorrow === maxTimelineDate && index === 0}
            onShowPathChange={onShowPathChange}
            visibleEvents={visibleEvents}
          />
        ))}
        {!Object.entries(entriesByDate).length && (
          <div className={classes.emptyHistoryContainer}>
            <div className={classes.emptyHistory}>
              History timeline is empty. When the vehicle connects all status and event updates will
              show here.
            </div>
          </div>
        )}
      </SPScrollbar>
    </div>
  );
};

VehicleHistoryTimeline.propTypes = {
  handleClick: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  entriesByDate: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.instanceOf(TimelineStatus),
        PropTypes.instanceOf(TripTimelineStatus),
        PropTypes.instanceOf(TimelineEvent),
      ]),
    ),
  ).isRequired,
  onShowPathChange: PropTypes.func.isRequired,
  visibleEventTimestamp: PropTypes.string,
  visibleEvents: PropTypes.array,
  updating: PropTypes.bool,
};

VehicleHistoryTimeline.defaultProps = {
  visibleEventTimestamp: "",
  visibleEvents: [],
  updating: false,
};

export default withStyles(vehicleHistoryStyles)(VehicleHistoryTimeline);
